var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserCircleOutline = function SvgUserCircleOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0M8 21.164V21c0-2.206 1.794-4 4-4s4 1.794 4 4v.164A9.9 9.9 0 0 1 12 22a9.9 9.9 0 0 1-4-.836m9.925-1.113A6.01 6.01 0 0 0 12 15a6.01 6.01 0 0 0-5.925 5.051A10 10 0 0 1 2 12C2 6.486 6.486 2 12 2s10 4.486 10 10a10 10 0 0 1-4.075 8.051M12 5C9.794 5 8 6.794 8 9s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4m0 6c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2"
  })));
};
export default SvgUserCircleOutline;